/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-pixel-dimensions',
  template: `
    <span *ngIf="width">{{width}}&times;{{height}}</span>
    <span *ngIf="!width">-</span>
  `
})
export class PixelDimensionsOutputComponent {
  @Input() width: number;
  @Input() height: number;
}
